import React, { useEffect, useState } from 'react'
import { useBuyapowa } from 'app/hooks'
import { Buyapowa } from './Buyapowa'
import { CookiesNotification } from './CookiesNotification'
import { useConfig } from '@ynap/immutables-provider'

export const ReferAFriend = ({
    country,
    messages,
    rootElem,
    errorElem,
    buyapowaURL,
    buyapowaCampaign,
    buyapowaMarket,
    language,
    deviceType,
}) => {
    const [showCookiesNotification, setShowCookiesNotification] = useState(false)
    const config = useConfig()

    useEffect(() => {
        if (typeof window.cact === 'function') {
            window.cact('consent.get', ({ consent }) => {
                const privacyId = config.head?.buyapowaPrivacyId
                if (!privacyId) return
                const buyapowaCategory = consent.categories[privacyId] || {}
                return buyapowaCategory.status === 'on'
                    ? setShowCookiesNotification(false)
                    : setShowCookiesNotification(true)
            })
        }
    }, [])

    const loading = useBuyapowa({
        language,
        country,
        rootElem,
        errorElem,
        buyapowaURL,
        buyapowaCampaign,
        buyapowaMarket,
    })

    return showCookiesNotification ? (
        <CookiesNotification title={messages.referrals.title()} message={messages.referrals.cookieMessage()} />
    ) : (
        <Buyapowa
            title={messages.referrals.title()}
            rootElem={rootElem}
            errorElem={errorElem}
            loading={loading}
            messages={messages}
            language={language}
            country={country}
            deviceType={deviceType}
        />
    )
}
